import React from 'react';
import {
  Box,
  Table,
  TableHead,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  useTheme,
  useMediaQuery,
  Card,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import { makeStyles } from '@material-ui/core';
import AddressFieldTools from 'components/AddressFieldTools';
import { decimalRoundingOfNumber } from 'helpers/numbers';

const useStyles = makeStyles((theme) => ({
  tablecontainer: {},
  tableRow: {
    '& .MuiTableCell-root': {
      fontFamily: 'BeVietnamPro, sans-serif', // Custom font
      fontSize: '14px', // Font size
      color: '#333' // Text color
    }
  }
}));

const InvestorTableSummary = ({ data, page }) => {
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  let fifthColumn;

  if (page === 'ALLOTMENT') {
    if (data?.total_quantity && data?.weighted_price) {
      fifthColumn = decimalRoundingOfNumber(data.total_quantity * data.weighted_price);
    } else {
      fifthColumn = '-';
    }
  } else {
    fifthColumn = decimalRoundingOfNumber(data?.avg_buy_price) ?? '-';
  }

  const classes = useStyles();
  if (!data) return null;

  if (isMobile) {
    return (
      <Card sx={{ border: '1px solid #BBBBBB', borderRadius: '8px', p: 2, mb: 2 }}>
        <List dense>
          <ListItem>
            <ListItemText
              primary="Token Symbol"
              secondary={
                page === 'ALLOTMENT'
                  ? data?.token_subscription_id?.token_id?.token_name
                  : data?.token?.token_name
              }
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ overflow: 'hidden' }}>
            <ListItemText
              primary="Token Address"
              secondary={
                <AddressFieldTools
                  address={
                    page === 'ALLOTMENT'
                      ? data?.token_subscription_id?.token_id?.deployment_address
                      : data?.token?.deployment_address
                  }
                  decimals={0}
                  showCopyButton
                  showInBlockExplorer
                />
              }
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary={page === 'ALLOTMENT' ? 'Token Holding' : 'Token Redeemed'}
              secondary={data?.total_quantity}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary={page === 'ALLOTMENT' ? 'Avg. buy Price ($)' : 'Avg. sell Price ($)'}
              secondary={data?.weighted_price ? decimalRoundingOfNumber(data.weighted_price) : '-'}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary={page === 'ALLOTMENT' ? 'Value at Cost ($)' : 'Avg. buy Price ($)'}
              secondary={fifthColumn}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Current Price ($)"
              secondary={page === 'ALLOTMENT' ? data?.token_nav : data?.token?.token_nav}
            />
          </ListItem>
          {page !== 'ALLOTMENT' && (
            <>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Realized P&L ($)"
                  secondary={
                    page === 'ALLOTMENT'
                      ? decimalRoundingOfNumber(
                          (data?.total_quantity ?? 0) *
                            ((data?.token_nav ?? 0) - (data?.weighted_price ?? 0))
                        )
                      : decimalRoundingOfNumber(
                          (data?.total_quantity ?? 0) *
                            ((data?.weighted_price ?? 0) - (data?.avg_buy_price ?? 0))
                        )
                  }
                />
              </ListItem>
            </>
          )}
        </List>
      </Card>
    );
  }
  return (
    <Box
      sx={{
        border: '1px solid #BBBBBB',
        borderRadius: '0px',
        boxShadow: 1
      }}
    >
      <TableContainer sx={{ width: '100%' }}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow
              // className={classes.tableRow}
              sx={{ fontWeight: '500' }}
            >
              <TableCell sx={{ fontWeight: 'bold', px: 6 }}>Token Symbol</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Token Address</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                {page === 'ALLOTMENT' ? 'Token Holding' : 'Token Redeemed'}
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                {page === 'ALLOTMENT' ? 'Avg. buy Price ($)' : 'Avg. sell Price ($)'}
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                {page === 'ALLOTMENT' ? 'Value at Cost ($)' : 'Avg. buy Price ($)'}
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Current Price ($)</TableCell>
              {page !== 'ALLOTMENT' && (
                <TableCell sx={{ fontWeight: 'bold' }}>Realized P&L ($)</TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {data && (
              <TableRow>
                {/* <Typography variant="body1" sx={{ color: 'text.primary',fontFamily:'BeVietnamPro', maxWidth:'150px' }} noWrap> */}
                <TableCell sx={{ px: 6 }}>
                  {page === 'ALLOTMENT'
                    ? data?.token_subscription_id?.token_id?.token_name
                    : data?.token?.token_name}
                </TableCell>
                {/* </Typography> */}
                <TableCell>
                  <Typography
                    variant="body1"
                    sx={{ color: 'text.primary', fontFamily: 'BeVietnamPro', maxWidth: '200px' }}
                    noWrap
                  >
                    <AddressFieldTools
                      address={
                        page === 'ALLOTMENT'
                          ? data?.token_subscription_id?.token_id?.deployment_address
                          : data?.token?.deployment_address
                      }
                      decimals={0}
                      showCopyButton
                      showInBlockExplorer
                    />
                  </Typography>
                </TableCell>
                <TableCell>{data?.total_quantity}</TableCell>
                <TableCell>
                  {data?.weighted_price ? decimalRoundingOfNumber(data.weighted_price) : '-'}
                </TableCell>
                <TableCell>{fifthColumn}</TableCell>
                <TableCell>
                  {page === 'ALLOTMENT' ? data?.token_nav : data?.token?.token_nav}
                </TableCell>
                {page !== 'ALLOTMENT' && (
                  <TableCell>
                    {page === 'ALLOTMENT'
                      ? decimalRoundingOfNumber(
                          (data?.total_quantity ?? 0) *
                            ((data?.token_nav ?? 0) - (data?.weighted_price ?? 0))
                        )
                      : decimalRoundingOfNumber(
                          (data?.total_quantity ?? 0) *
                            ((data?.weighted_price ?? 0) - (data?.avg_buy_price ?? 0))
                        )}
                  </TableCell>
                )}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InvestorTableSummary;
